import {getFeatureFlags, LocalStorage} from '@chekin/core';
import {LAYOUT_MODE_KEY} from 'utils/constants';

export type TerminalMode = 'kiosko' | 'unattended' | null;

const LAYOUT_PARAM = 'layout';
const CLEAR_VALUE = 'default';

const isTerminalMode = (value?: string | null): value is NonNullable<TerminalMode> =>
  value === 'kiosko' || value === 'unattended';

const stripLayoutParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete(LAYOUT_PARAM);
  window.history.replaceState({}, '', url.toString());
};

const resolveTerminalMode = (): TerminalMode => {
  const fromUrl = new URL(window.location.href).searchParams.get(LAYOUT_PARAM);

  if (fromUrl !== null) {
    stripLayoutParam();
  }

  if (fromUrl === CLEAR_VALUE) {
    LocalStorage.remove(LAYOUT_MODE_KEY);
    return null;
  }

  if (isTerminalMode(fromUrl)) {
    if (fromUrl === 'unattended') {
      LocalStorage.set(LAYOUT_MODE_KEY, fromUrl);
    }

    return fromUrl;
  }

  const persisted = LocalStorage.get<string>(LAYOUT_MODE_KEY);
  return isTerminalMode(persisted) ? persisted : null;
};

export const requestedTerminalMode: TerminalMode = resolveTerminalMode();

export const isUnattendedTerminal = () =>
  requestedTerminalMode === 'unattended' &&
  Boolean(getFeatureFlags('GUESTAPP_REDESIGN_ENABLED')) &&
  Boolean(getFeatureFlags('UNATTENDED_TERMINAL_ENABLED'));

export const isTerminalSession = () =>
  requestedTerminalMode !== null ||
  LocalStorage.get<string>(LAYOUT_MODE_KEY) === 'kiosko';
